import React, { useState, useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import compose from 'helpers/compose';
import { withRouter } from 'react-router-dom';

import Container from '@material-ui/core/Container';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
} from '@material-ui/core';

import Background from 'components/Layout/Background';

import { RootStore } from 'stores/rootStore';
import { AdminConstantsStore } from 'stores/admin/adminConstantsStore';

interface Props {
  rootStore: RootStore;
}

const Constants: React.FC<Props> = ({ rootStore }) => {
  const { t } = useTranslation();
  const [store] = useState(new AdminConstantsStore(rootStore));
  const { data, fetchData } = store;

  useEffect(() => {
    fetchData();
  }, [fetchData, store]);

  return (
    <Background>
      <Container maxWidth="md">
        <Typography variant="h1">{t('admin_constants_title')}</Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Jméno</TableCell>
              <TableCell>Hodnota</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data ? (
              Object.entries(data).map((row) => (
                <TableRow key={row[0]}>
                  <TableCell component="th">{row[0]}</TableCell>
                  <TableCell>{row[1]}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2}>
                  <CircularProgress size={20} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Container>
    </Background>
  );
};

export default compose(inject('rootStore'), withRouter, observer)(Constants);
